export default function ArrowUpIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11.5858L18 13L18 13L16.5857 13L12.9999 9.41421L12.9999 18L10.9999 18L10.9999 9.41423L7.41417 13L5.99994 13L5.99994 11.5858L11.2928 6.2929L11.9999 5.5858L12.707 6.2929L18 11.5858Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
